import gql from 'graphql-tag';
import { OrderAllData } from '../fragments';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';

export default gql`
query Order(
    $filters: OrderFilters
    $sortBy: OrderSort
    $count: Int!
    $page: Int
) {
    orders(
        filters: $filters
        sortBy: $sortBy
        first: $count
        page: $page
    ) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...OrderAllData
        }
    }
}
${PaginatorInfoFragment}
${OrderAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/order.ts